import "./ConnectWithSales.module.css";
import Navigation from "@/reusable_sections/Header";
import Inquiry from "./sections/Inquiry";
import Locations from "./sections/Locations";
import SalesChannels from "./sections/SalesChannels";
import Footer from "@/reusable_sections/Footer";
export default function ConnectWithSalesPage() {
  return <div>
      <Navigation />
      <Inquiry />
      <Locations />
      <SalesChannels />
      <Footer />
    </div>;
}